import LiveGameAnalysis from "../../analysis/LiveGameAnalysis";
const GameEndPopup = () => {
  return <div></div>;
};

export default GameEndPopup;
